<template>
    <div class="environment-wraper"
    v-bind:class="[hideAimate]"
    >

        <AreaComponents
            v-bind:curentEnvironment="curentEnvironment"
            v-bind:curentSolution="curentSolution"
            v-bind:typeSol="typeSol"
            v-bind:displayType="displayType"
            v-on:selectSolution="selectSolution"
            v-on:setDesktopSize="setDesktopSize"
            v-on:setShowPage="setShowPage"
        />
        <NavEnv
            v-bind:curentEnvironment="curentEnvironment"
            v-bind:activeEnv="activeEnv"

            v-bind:displayType="displayType"

            v-on:setActiveEnv="setActiveEnv"

            v-bind:typeSol="typeSol"
            v-bind:switchDisable="switchDisable"
            v-on:changeTypeSol="changeTypeSol"

            v-on:setShowPage="setShowPage"

            v-on:toLandingPage="toLandingPage"
            v-on:onBack="toLandingPage"
        />

        <!--<transition name="fade">-->
        <!--<PageSection-->
        <!--v-bind:showPage="showPage"-->
        <!--v-bind:curentEnvironment="curentEnvironment"-->
        <!--v-if="showPage"-->
        <!--:key="showPage"-->
        <!--v-on:closePage="closePage"-->
        <!--/>-->
        <!--</transition>-->
        <!--<div class="hiden-preload-image">-->
        <!--<img-->
        <!--v-for="url  in envListImages" -->
        <!--:src="url" alt="">-->
        <!--</div>-->


        <video preload="auto"
               v-for="item in envSlugsProcessed"
            :key="item.id"
            class="media-section video video-from"
            v-bind:class="[item.id+'video',{active:item.id==goFrom}]"
            :ref="item.id+'video_from'"
            :id="item.id+'video_from'"
            muted
            v-on:ended="videoCompletedFrom(item.id+'video_from')">

            <source  :src="subdir+'/images/slider/'+item.file+'_from.mp4'" type="video/mp4">
            <source :src="subdir+'/images/slider/webm/'+item.file+'_from.webm'" type="video/webm">
        </video>

        <div class="btn go-to  d-none d-lg-flex"
             v-if="this.curentEnvironment.slug!='tech-bar-meeting-room'"
             @click="toLandingPage"
        > back
        </div>

        <div class="media-wraper">
            <video preload="auto"
                   class="media-section video video-to"
                v-bind:class="{show:goRoom}"
                ref="meetingRoomTo"
                id="meetingRoomTo"
                muted
                v-on:ended="videoCompletedToRoom">

                <source  :src="subdir+'/images/slider/tech-bar-meeting-room_to.mp4'" type="video/mp4">
                <source :src="subdir+'/images/slider/webm/tech-bar-meeting-room_to.webm'" type="video/webm">
            </video>
            <video
                class="media-section video video-to"
                v-bind:class="{show:fromRoom}"
                ref="meetingRoomFrom"
                id="meetingRoomFrom"
                muted
                v-on:ended="videoCompletedFromRoom">

                <source  :src="subdir+'/images/slider/tech-bar-meeting-room_from.mp4'" type="video/mp4">
                <source :src="subdir+'/images/slider/webm/tech-bar-meeting-room_from.webm'" type="video/webm">
            </video>

        </div>
        <div
            class="btn go-to meeting-room meeting  d-none d-lg-flex"
            v-if="goRoom===null && curentEnvironment.slug=='tech-bar'"
            @click="toMeetingRoom"
        >enter<br>meeting<br>room</div>
        <div
            class="btn go-to meeting-room  d-none d-lg-flex"
            v-if="fromRoom===null && curentEnvironment.slug=='tech-bar-meeting-room'"
            @click="fromMeetingRoom"
        > back
        </div>
        <div class="label"
             v-if="false">{{curentEnvironment.slug}}{{curentEnvironment.id}}
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'

    import NavEnv from '@/components/NavEnv.vue'
    // import NavSections from '@/components/NavSections.vue'
    import AreaComponents from '@/components/AreaComponents.vue'
    // import PageSection from "../components/PageSection.vue";


    export default {
        name: 'Environments',
        components: {
            // NavSections,
            AreaComponents, NavEnv,
            // PageSection
        },
        props: ['selectEnvironments', 'activeEnv', 'envListImages'],
        data() {
            return {
                displayType: 'mob', //mob,tab,desk
                // activeEnvID: null,
                curentEnvironment: {},
                curentSolution: false,
                envpagedata: {},
                typeSol: false, // false = (Digital Workplace), true = (Smart Infrastructure)
                switchDisable: true, // false = (Digital Workplace), true = (Smart Infrastructure)
                showPage: false,
                goFrom: null,

                goRoom: null,
                fromRoom: null,
                hideAimate:'hidy',
            }
        },
        computed: {
            ...mapGetters({
                subdir: 'environments/subdir',
                environments: 'environments/environments',
                solutions: 'environments/solutions',
                envSlugs: 'environments/envSlugs',
            }),

            envSlugsProcessed() {
                return this.envSlugs.map((item) => {
                    let list = {
                        ...item,
                        // videoFromStyle: 'z-index:10;',
                    };
                    // if (this.goFrom !== null) {
                    //
                    //     list.videoFromStyle = index == this.goFrom ? 'z-index:100;' : 'z-index:0;';
                    //
                    //
                    // } else {
                    //
                    //     list.imgStyle = index == this.currentID ? 'z-index:100;' : 'z-index:0;';
                    //
                    // }
                    return list;
                });
            },
        },
        watch: {
            'activeEnv'() {
                this.setDisableSwitcher(this.activeEnv);
            },
        },
        mounted() {

            if (this.activeEnv) {
                this.curentEnvironment = this.getEnvironmentFromID(this.activeEnv);
                this.hideAimate = '';
            } else {
                this.$emit('setActiveEnv', this.environments[0].id);
            }
            this.setDisableSwitcher(this.activeEnv);

        },
        methods: {

            toLandingPage() {
                if (this.curentEnvironment.slug == 'tech-bar-meeting-room') {
                    return false;
                }

                // if(this.goFrom!==null){
                //     const el = this.envSlugs[this.goFrom].id + 'video_from';
                //     this.$refs[el][0].play();
                // }

                this.$store.dispatch('environments/setActiveEnvSlug', this.curentEnvironment.slug);
                this.$store.dispatch('environments/setFlyPreviewActive', false);

                this.$store.dispatch('environments/setFrontPagePreload', false);
                this.$store.dispatch('environments/setShowMenuInLanding', true);

                // this.$store.dispatch('environments/setGoFrom', this.curentEnvironment.slug);
                let el = this.envSlugs.find((item) => {
                    return item.slug == this.curentEnvironment.slug
                })
                this.goFrom = el.id
                const video = this.goFrom + 'video_from';
                this.$refs[video][0].play();

            },
            videoCompletedFrom(ref) {
                let el = this.envSlugs.find((item) => {
                    return item.slug == this.curentEnvironment.slug
                })
                this.$store.dispatch('environments/setBgImage', this.subdir+'/images/slider/'+el.file+'.jpg');
                this.$store.dispatch('environments/setGoFrom', null);

                this.hideAimate = 'hidy'
                setTimeout(()=>{
                    this.$router.push({name: 'Landing'});
                },100)

                setTimeout(()=>{
                    this.$refs[ref][0].currentTime = 0;
                },1)
            },
            setDisableSwitcher(id) {
                this.curentEnvironment = this.getEnvironmentFromID(id);
                this.curentSolution = false;
                if (this.curentEnvironment.image && this.curentEnvironment.image_smart) {
                    this.switchDisable = false;
                } else {
                    this.switchDisable = true;
                    if (this.curentEnvironment.image) {
                        this.typeSol = false;
                    } else {
                        this.typeSol = true;
                    }
                }
            },
            setActiveEnv(env_id) {
                this.$emit('setActiveEnv', env_id);
            },
            selectSolution(sol_id) {
                if (sol_id) {
                    this.curentSolution = this.solutions[sol_id];
                } else {
                    this.curentSolution = false
                }
            },
            changeTypeSol(type) {
                this.typeSol = type;
            },
            getEnvironmentFromID(id) {
                let elEnv = {
                    ...this.environments.find((el) => {
                        return el.id == id;
                    })
                }

                if (Object.prototype.hasOwnProperty.call(elEnv, "solutions")) {
                    elEnv.solutions = elEnv.solutions.map((item) => ({
                        ...item,
                        title: this.solutions[item.id].title
                    }))
                }

                return elEnv;
            },
            setShowPage(page) {
                this.showPage = page;
            },
            closePage() {
                this.showPage = '';
            },
            setDesktopSize(type) {
                this.displayType = type;
            },

            videoCompletedToRoom() {
                // this.$store.dispatch('environments/setGoFrom', null);
                // this.$router.push({name: 'Landing'});
                console.log("this.getEnvDBid('tech-bar')", this.getEnvDBid('tech-bar'))
                this.setActiveEnv(this.getEnvDBid('tech-bar-meeting-room'));
                this.goRoom = null;
            },
            videoCompletedFromRoom() {
                this.setActiveEnv(this.getEnvDBid('tech-bar'));
                this.fromRoom = null;
                // meeting_room_from
            },
            toMeetingRoom() {
                // meetingRoomTo
                this.goRoom = true
                this.$refs.meetingRoomTo.play();
                this.$store.dispatch('environments/setBgImage', this.subdir+'/images/environments/tech-bar-meeting-room.jpg');
            },
            fromMeetingRoom() {
                this.fromRoom = true
                this.$refs.meetingRoomFrom.play();
                this.$store.dispatch('environments/setBgImage', this.subdir+'/images/environments/tech-bar.jpg');
            },

            getEnvDBid(slug) {
                console.log('slug',slug);
                let sl = 1;
                // console.log('environments:',this.environments)
                sl = this.environments.find((item) => {
                    return item.slug == slug;
                });
                return sl.id;
            },
        },
    }

</script>
<style lang="scss" scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */
    {
        opacity: 0;
    }

    .environment-wraper .btn.go-to.meeting-room {
        bottom: 60px;
    }

    .media-wraper {
        .video {
            z-index: -1;
            opacity: 0;
            transition: z-index 0.1s step-end, opacity 0.1s linear;
            &.show {
                z-index: 1;
                opacity: 1;
                transition: z-index 0.1s step-end, opacity 0.1s linear;
            }
        }
    }
</style>